import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { HttpInterceptorService, RESTService } from '@covalent/http';
import { MOCK_API } from '../config/api.config';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { environment } from '../environments/environment';
import 'rxjs/add/operator/map';

@Injectable()
export class HojaDeConsultaService extends RESTService<any> {

  constructor(private _http: HttpInterceptorService) {
    super(_http, {
      baseUrl: MOCK_API,
      path: '/hojadeconsulta',
    });
  }

  agregarDatosAdministrativos(numeroExpediente: string): any {
    // Parametros fijos
    let params: any = {
      iContador: numeroExpediente,
    };
    return this._http.post(environment.api_host + 'hojaDeConsulta/agregarDatosAdministrativos', params).map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Service error'));
  }

  obtenerHojaDeConsulta(codCentro: string, fecha: string, codAgenda: string): any {
    // Parametros fijos
    let params: any = {
      fecha: fecha,
      codCentro: codCentro,
      codAgenda: codAgenda,
    };
    return this._http.post(environment.api_host + 'hojaDeConsulta/obtenerHojaDeConsulta', params).map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Service error'));
  }

  comprobarVisita(numeroExpediente: string, dniMedico: string, cita: string, iesp: string, iesppr: string): any {
    // Parametros fijos
    let params: any = {
      numeroExpediente: numeroExpediente,
      dniMedico: dniMedico,
      cita: cita,
      iesp: iesp,
      iesppr: iesppr,
      iespae: '0',
    };
    return this._http.post(environment.api_host + 'hojaDeConsulta/comprobarVisita', params).map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Service error'));
  }

  actualizarEstado(dniMedico: string, cita: string, presente: boolean): any {
    // Parametros fijos
    let params: any = {
      dniMedico: dniMedico,
      cita: cita,
      valor: !presente ? 'S' : 'N',
      presente: !presente,
    };
    return this._http.post(environment.api_host + 'hojaDeConsulta/actualizarEstado', params).map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Service error'));
  }

}



// WEBPACK FOOTER //
// ./src/services/hojadeconsulta.service.ts